import { render, staticRenderFns } from "./svgTwitter.vue?vue&type=template&id=2c1cb931&scoped=true"
import script from "./svgTwitter.vue?vue&type=script&lang=js"
export * from "./svgTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1cb931",
  null
  
)

export default component.exports